import clsx from 'clsx'
import { OTPInput, SlotProps } from 'input-otp'

interface Props {
  name: string
  value: string
  invalid: boolean
  onChange: (newValue: string) => void
  onComplete: () => void
}

export default function CodeInput({
  value,
  name,
  invalid,
  onChange,
  onComplete
}: Props) {
  return (
    <OTPInput
      value={value}
      aria-invalid={invalid}
      onChange={onChange}
      onComplete={onComplete}
      name={name}
      maxLength={6}
      containerClassName="group flex items-center has-disabled:opacity-30"
      pushPasswordManagerStrategy="none"
      data-1p-ignore
      data-lpignore="true"
      autoComplete="one-time-code"
      data-protonpass-ignore="true"
      autoFocus
      render={({ slots }) => (
        <>
          <div className="flex">
            {slots.slice(0, 3).map((slot, idx) => (
              <Slot key={idx} {...slot} />
            ))}
          </div>

          <FakeDash />

          <div className="flex">
            {slots.slice(3).map((slot, idx) => (
              <Slot key={idx} {...slot} />
            ))}
          </div>
        </>
      )}
    />
  )
}

// Feel free to copy. Uses @shadcn/ui tailwind colors.
function Slot(props: SlotProps) {
  return (
    <div
      className={clsx(
        'relative w-10 h-14 text-[2rem] text-text',
        'flex items-center justify-center',
        'transition-all duration-100',
        'border-text-light border-y border-r first:border-l first:rounded-l-small last:rounded-r-small',
        'group-focus-within:border-secondary',
        'outline-solid outline-0',
        props.isActive && 'outline-2 outline-primary'
      )}
    >
      <div className="group-has-[input[data-input-otp-placeholder-shown]]:opacity-20">
        {props.char ?? props.placeholderChar}
      </div>
      {props.hasFakeCaret && <FakeCaret />}
    </div>
  )
}

// You can emulate a fake textbox caret!
function FakeCaret() {
  return (
    <div className="absolute pointer-events-none inset-0 flex items-center justify-center animate-pulsate">
      <div className="w-px h-8 bg-white" />
    </div>
  )
}

// Inspired by Stripe's MFA input.
function FakeDash() {
  return (
    <div className="flex w-10 justify-center items-center">
      <div className="w-3 h-1 rounded bg-text-light" />
    </div>
  )
}
